import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Page } from 'components/common';
import { Trans } from "react-i18next";
const Success = () => {
  const history = useHistory();

  useEffect(() => {
    const redirectTimeout = setTimeout(() => {
      history.push('/home');
    }, 15000);

    return () => clearTimeout(redirectTimeout); 
  }, [history]);

  const handleManualRedirect = () => {
    history.push('/home');
  };

  return (
    <Page title="" className="text-center mt-3">
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6 text-center">
            <h1 className="display-4 font-weight-bold text-success"><Trans>Success!</Trans></h1>
            <p className="lead"><Trans>Your password has been set successfully.</Trans></p>
            <h4 className="mb-4"><Trans>Welcome to Hesaab</Trans></h4>
            <p className="mb-3"><Trans>You are now logged in.</Trans></p>
            <p className="mb-3"><Trans>You will be redirected to the Hesaab home page in</Trans> <strong>15</strong> <Trans>seconds.</Trans></p>
            <p className="mb-4"><Trans>Or you can click the button below to go directly.</Trans></p>
            <button onClick={handleManualRedirect} className="btn btn-primary btn-lg">
            <Trans>  Go To Home</Trans>
            </button>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Success;
